import { TranslationKeys } from 'locales/translationKeys'

type Feature = {
  label: TranslationKeys
  description: TranslationKeys
}

export const features: Feature[] = Array(4)
  .fill('')
  .map((_, i) => ({
    label: `home:live-better.features.${i}.label` as TranslationKeys,
    description: `home:live-better.features.${i}.description` as TranslationKeys,
  }))
